import {Component, OnInit} from '@angular/core';
import {Router, NavigationEnd} from '@angular/router';

import {DocumentoGlobal} from './../_shared/documento/documento-global';
import {SessionService} from './../_shared/session/session.service';
import {CandidatoService} from '../_shared/candidato/candidato.service';
import {DocumentoService} from '../_shared/documento/documento.service';
import {Candidato} from '../_shared/candidato/candidato';

@Component({
    selector: 'app-diploma',
    templateUrl: './diploma.component.html',
    styleUrls: ['./diploma.component.css']
})
export class DiplomaComponent implements OnInit {

    public documentos = new Array<any>();

    constructor(private router: Router,
                private DocumentoService: DocumentoService,
                private SessionService: SessionService,
                private DocumentoGlobal: DocumentoGlobal,
                public CandidatoService: CandidatoService) {

        this.DocumentoGlobal.adicionaDocumentoEmitter.subscribe(documento => this.adicionaDocumento(documento));

        this.DocumentoGlobal.removeDocumentoEmitter.subscribe(documento => this.removeDocumento(documento));

        this.DocumentoGlobal.imagemDocumentoEmitter.subscribe(documento => this.adicionaImagem(documento));

        this.DocumentoGlobal.tipoDocumentoEmitter.subscribe(documento => this.adicionaTipo(documento));
    }

    adicionaDocumento(adicionaDocumento) {
        this.documentos = this.DocumentoGlobal.adicionaDocumentoGlobal(this.documentos, adicionaDocumento);
    }

    removeDocumento(removerDocumento) {
        this.documentos = this.DocumentoGlobal.removeDocumentoGlobal(this.documentos, removerDocumento);
    }

    adicionaImagem(documentoImagem) {
        this.documentos = this.DocumentoGlobal.adicionaImagemGlobal(this.documentos, documentoImagem);
    }

    adicionaTipo(documentoTipo) {
        this.documentos = this.DocumentoGlobal.adicionaTipoGlobal(this.documentos, documentoTipo);
    }

    ngOnInit() {
        const candidato: Candidato = this.CandidatoService.getCandidato();

        if (candidato.concluinte) {
            this.router.navigate(['/documentos']);

            return;
        }

        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0);
        });


        this.CandidatoService.getTodosDocumentos(this.DocumentoGlobal.getTipoDiploma())
            .subscribe(documentosCandidato => this.setDocumentos(documentosCandidato), err => err);
    }

    setDocumentos(documentosCandidato) {
        this.documentos = this.DocumentoGlobal.setDocumentos(documentosCandidato, this.DocumentoGlobal.getTipoDiploma());
    }

    proximo() {
        if (this.validaDocumentos()) {
            this.DocumentoService.uploadDocumentos(this.documentos);

            this.router.navigate(['/historico-escolar']);
        }
    }

    anterior() {
        this.router.navigate(['/documentos']);
    }


    validaDocumentos() {
        const result = this.DocumentoGlobal.validaDocumentosGlobal(this.documentos, this.DocumentoGlobal.getTipoDiploma());
        this.documentos = result[0];
        return result[1];
    }

}



// WEBPACK FOOTER //
// ./src/app/diploma/diploma.component.ts